import i18n from "src/app/shared/localization/i18n";

export const ConvertFromFilterToStatus = (filter: string): any => {
    let status = "";
    switch (filter) {
        case i18n.t('chats.missed'):
            status = "Missed";
            break;
        case i18n.t('chats.expired'):
            status = "Expired";
            break;
        case i18n.t('chats.finished'):
            status = "Finished";
            break;
    }
    return status;
}

export const ConvertFromFilterToChannelType = (filter: string): any => {
    let status = "";
    switch (filter) {
        case i18n.t('channels.instagram'):
            status = "Instagram";
            break;
        case i18n.t('channels.facebook'):
            status = "Facebook";
            break;
        case i18n.t('channels.telegram'):
            status = "Telegram";
            break;
        case i18n.t('channels.viber'):
            status = "Viber";
            break;
        case i18n.t('channels.vk'):
            status = "VK";
            break;
        case i18n.t('channels.weChat'):
            status = "WeChat";
            break;
        case i18n.t('channels.widget'):
            status = "Widget";
            break;
        case i18n.t('channels.uniformWidget'):
            status = "UniformWidget";
            break;
        case i18n.t('channels.whatsApp'):
            status = "WhatsApp";
            break;
        case i18n.t('channels.ednaWhatsApp'):
            status = "EdnaWhatsApp";
            break;
        case i18n.t('channels.voiceChannel'):
            status = "VoiceChannel";
            break;
        case i18n.t('channels.telegramPrivate'):
            status = "TelegramPrivate";
            break;
        case i18n.t('channels.sendPulse'):
            status = "SendPulse";
            break;
    }
    return status;
}

export const ConvertFromFilterToOperatorType = (filter: string): any => {
    let operatorType = "";
    switch (filter) {
        case i18n.t('operators.operatorTypeOperator'):
            operatorType = "Operator";
            break;
        case i18n.t('operators.operatorTypeBot'):
            operatorType = "Bot";
            break;
        case i18n.t('operators.operatorTypeSupervisor'):
            operatorType = "Supervisor";
            break;
        case i18n.t('operators.operatorTypeHuman'):
            operatorType = "Human";
            break;
        case i18n.t('operators.operatorTypeQueue'):
            operatorType = "Queue";
            break;
    }
    return operatorType;
}

export const ConvertFromFilterToChatType = (filter: string): any => {
    let chatType = "";
    switch (filter) {
        case i18n.t('chat.chatTypePrivate'):
            chatType = "Private";
            break;
        case i18n.t('chat.chatTypeGroup'):
            chatType = "Group";
            break;
        case i18n.t('chat.chatTypeComment'):
            chatType = "Comment";
            break;
        case i18n.t('chat.chatTypeMailing'):
            chatType = "Mailing";
            break;
    }
    return chatType;
}